import React from 'react';
import { useSearchParams } from 'react-router-dom';
import CVFormPreview from '../components/CV/CVFormPreview';
import CVEditor from '../components/CV/CVEditor';
import './CVCreateEditPage.scss';

const CVCreateEditPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const usePreview = searchParams.get('preview') !== 'false'; // Default to new WYSIWYG editor

  return (
    <div className="cv-create-edit-page">
      <div className={usePreview ? 'container-wide' : 'container'}>
        {usePreview ? <CVFormPreview /> : <CVEditor />}
      </div>
    </div>
  );
};

export default CVCreateEditPage;

